// 🚩 Denunciar (0.73): mensagem, contato ou grupo das Mensagens. Pergunta o motivo, grava no servidor
// e oferece bloquear a pessoa (o mesmo Bloquear da lista de amigos).
import { useState } from 'react';
import { Alert, ScrollView, Text, View } from 'react-native';
import { Btn, Chip, Field, Sheet } from './ui';
import { C } from './theme';
import { enviarDenuncia, type AlvoDenuncia, type MotivoDenuncia } from '../lib/denuncia';
import { responderAmizade } from '../lib/chat';
import { t } from '../lib/i18n';
import { ROLAGEM_TECLADO } from './teclado';

const MOTIVOS: { id: MotivoDenuncia; label: () => string }[] = [
  { id: 'spam', label: () => t('Spam') },
  { id: 'assedio', label: () => t('Assédio ou ameaça') },
  { id: 'improprio', label: () => t('Conteúdo impróprio') },
  { id: 'outro', label: () => t('Outro') },
];

/** Uso: const den = useDenunciar(cor, eu); ... den.abrir({ ... }); ... {den.janela} */
export function useDenunciar(cor: string, eu: string | null) {
  const [alvo, setAlvo] = useState<AlvoDenuncia | null>(null);
  const [motivo, setMotivo] = useState<MotivoDenuncia | null>(null);
  const [detalhe, setDetalhe] = useState('');
  const [indo, setIndo] = useState(false);

  const abrir = (a: AlvoDenuncia) => { setMotivo(null); setDetalhe(''); setAlvo(a); };
  const fechar = () => { if (!indo) setAlvo(null); };

  const enviar = async () => {
    if (!alvo || !motivo || indo) return;
    setIndo(true);
    const a = alvo;
    try { await enviarDenuncia(a, motivo, detalhe); }
    catch { /* a reserva por e-mail já foi tentada */ }
    finally { setIndo(false); setAlvo(null); }
    const pessoa = a.usuario ?? a.mensagem?.autor ?? null;
    const nome = a.mensagem?.autor_nome || a.nome || '';
    const podeBloquear = !!pessoa && pessoa !== eu && !a.grupo;
    setTimeout(() => Alert.alert('🚩 ' + t('Denúncia enviada'), t('Obrigado. Nossa equipe vai analisar em até 24 horas.'), podeBloquear ? [
      { text: t('Agora não'), style: 'cancel' },
      { text: t('Bloquear {nome}', { nome }), style: 'destructive', onPress: () => responderAmizade(pessoa!, 'bloquear')
        .then(() => Alert.alert(t('Bloqueado'), t('{nome} não pode mais conversar com você.', { nome })))
        .catch(e => Alert.alert(t('Não foi possível'), String(e?.message ?? e))) },
    ] : undefined), 300);
  };

  const titulo = alvo?.mensagem ? t('Denunciar mensagem') : alvo?.grupo ? t('Denunciar grupo') : t('Denunciar contato');
  const janela = (
    <Sheet visible={!!alvo} onClose={fechar} title={titulo}>
      <ScrollView {...ROLAGEM_TECLADO} contentContainerStyle={{ padding: 16, gap: 12 }} keyboardShouldPersistTaps="handled">
        {!!alvo?.mensagem && (
          <View style={{ backgroundColor: C.card, borderRadius: 12, padding: 10, gap: 2 }}>
            <Text style={{ color: C.sub, fontSize: 12, fontWeight: '700' }}>{alvo.mensagem.autor_nome}</Text>
            <Text style={{ color: C.text }} numberOfLines={4}>{alvo.mensagem.tipo === 'texto' ? alvo.mensagem.texto : t('Anexo')}</Text>
          </View>
        )}
        {!alvo?.mensagem && !!alvo?.nome && <Text style={{ color: C.text, fontWeight: '700', fontSize: 16 }}>{alvo.nome}</Text>}
        <Text style={{ color: C.sub }}>{t('Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.')}</Text>
        <View style={{ flexDirection: 'row', gap: 8, flexWrap: 'wrap' }}>
          {MOTIVOS.map(m => <Chip key={m.id} cor={cor} on={motivo === m.id} label={m.label()} onPress={() => setMotivo(m.id)} />)}
        </View>
        <Field value={detalhe} onChangeText={setDetalhe} placeholder={t('Conte mais (opcional)')} multiline maxLength={800}
          style={{ minHeight: 90, textAlignVertical: 'top' }} />
        <Btn cor={C.danger} disabled={!motivo || indo} label={indo ? t('Enviando...') : '🚩 ' + t('Enviar denúncia')} onPress={enviar} />
        <Text style={{ color: C.mute, fontSize: 12 }}>{t('Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.')}</Text>
      </ScrollView>
    </Sheet>
  );
  return { abrir, janela };
}
